import type { Language } from "@bt/domain";
import { useTranslation } from "react-i18next";
import { Segmented } from "@/components/ui/misc";
import { Select } from "@/components/ui/select";
import { useLanguages } from "@/lib/languages";

/**
 * Picks one of the offered languages: side by side while there are two, a select from three on,
 * which a phone's width still holds. A community translation says so next to its name.
 */
export function LanguagePicker({
  value,
  onChange,
  className,
  "aria-label": ariaLabel,
}: {
  value: Language;
  onChange: (language: Language) => void;
  className?: string;
  "aria-label"?: string;
}) {
  const { t } = useTranslation();
  const languages = useLanguages();
  if (languages.length <= 2) {
    return (
      <Segmented<Language>
        className={className}
        aria-label={ariaLabel}
        value={value}
        onChange={onChange}
        options={languages.map((l) => ({ value: l.code, label: l.name }))}
      />
    );
  }
  return (
    <Select<Language>
      className={className}
      aria-label={ariaLabel}
      value={value}
      onValueChange={onChange}
      options={languages.map((l) => ({
        value: l.code,
        label:
          l.status === "community" || l.status === "draft" ? (
            <span>
              {l.name}{" "}
              <span className="text-muted-foreground">
                · {t(`settings.languageStatus.${l.status}`)}
              </span>
            </span>
          ) : (
            l.name
          ),
      }))}
    />
  );
}
